// eslint-disable-next-line import/no-cycle
import { gkcl117, gkcl162 } from './pages';

const targetPageFromStore = {
	taskOverview: 'GKCL-117',
	campaignsList: 'GKCL-162',
};

export const targetPages = {
	[targetPageFromStore.taskOverview]: gkcl117,
	[targetPageFromStore.campaignsList]: gkcl162,
};

export const REDIRECT_INFO = '1';
